import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

interface TagInputData {
    display: string;
    value: string;
}

@Component({
    selector: 'app-tag-input',
    templateUrl: './tag-input.component.html',
    styleUrls: ['./tag-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TagInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class TagInputComponent implements OnChanges, OnInit, ControlValueAccessor {

    @Input() placeholder = '+ Add Item';
    @Input() modelAsStrings = false;
    @Input() disable = false;

    @Output() addItemEvt = new EventEmitter<string | TagInputData>();
    @Output() removeItemEvt = new EventEmitter<string | TagInputData>();

    tags: any[] = [];
    inputValue = '';

    private onChange: (val: any) => void = () => {};
    onTouched: () => void = () => {};

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disable) {
            this.changeDetectorRef.detectChanges();
        }
    }

    ngOnInit(): void {}

    writeValue(val: any): void {
        this.tags = Array.isArray(val) ? [...val] : [];
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    addTag(): void {
        const value = this.inputValue.trim();
        if (!value || this.disable) return;

        this.tags.push(value);
        this.inputValue = '';
        this.onChange({inputCtrl: this.tags});
        this.addItemEvt.emit({ display: value, value });
    }

    removeTag(index: number): void {
        if (this.disable) return;
        const removed = this.tags.splice(index, 1)[0];
        this.onChange({inputCtrl: this.tags});
        this.removeItemEvt.emit(this.modelAsStrings ? removed : { display: removed, value: removed });
    }

    onKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.addTag();
        }
    }
}
